"use client"

import ChooseUsSection from "../MobileApp/ChooseUsSection/ChooseUsSection";
import CodeAuditSection from "../MobileApp/CodeAuditSection/CodeAuditSection";
import DigitalSolutionsSection from "../MobileApp/DigitalSolutionsSection/DigitalSolutionsSection";
import IndustryGrowthSection from "../MobileApp/IndustryGrowthSection/IndustryGrowthSection";
import MobileAppTestimonialSection from "../MobileApp/MobileAppTestimonialSection/MobileAppTestimonialSection";
import MobileContactSection from "../MobileApp/MobileContactSection/MobileContactSection";
import MobileCTASection from "../MobileApp/MobileCTASection/MobileCTASection";
import MobileHeroSection from "../MobileApp/MobileHeroSection/MobileHeroSection";
import MobileProcessSection from "../MobileApp/MobileProcessSection/MobileProcessSection";


const MobileAppLayout = ({ data }) => {
  return (
    <>
     <MobileHeroSection hero={data.hero} />
      <IndustryGrowthSection industry={data.industryGrowth} />
      <DigitalSolutionsSection solutions={data.solutions} />
      <ChooseUsSection chooseUs={data.chooseUs} />
      <MobileProcessSection process={data.process} />
      <CodeAuditSection codeaudit={data?.codeaudit} />
      <MobileAppTestimonialSection />
      <MobileContactSection contact={data.contact} />
      <MobileCTASection cta={data.cta} />
    </>
  );
};

export default MobileAppLayout